// CRT Terminal Color Palette
export const CRT_COLORS = {
  green: {
    name: "Green Phosphor",
    screen: "#001200",
    text: "#00ff41",
    dim: "#00882a",
    glow: "0 0 15px rgba(0,255,65,0.2), 0 0 40px rgba(0,255,65,0.06)",
    border: "#003300",
    accent: "#33ff66",
  },
  amber: {
    name: "Amber",
    screen: "#120e00",
    text: "#ffb000",
    dim: "#996a00",
    glow: "0 0 15px rgba(255,176,0,0.2), 0 0 40px rgba(255,176,0,0.06)",
    border: "#332200",
    accent: "#ffc233",
  },
  cyan: {
    name: "Cyan",
    screen: "#001218",
    text: "#00f0ff",
    dim: "#008899",
    glow: "0 0 15px rgba(0,240,255,0.2), 0 0 40px rgba(0,240,255,0.06)",
    border: "#003340",
    accent: "#33f5ff",
  },
  pink: {
    name: "Pink",
    screen: "#120010",
    text: "#ff2d95",
    dim: "#991a5a",
    glow: "0 0 15px rgba(255,45,149,0.2), 0 0 40px rgba(255,45,149,0.06)",
    border: "#330020",
    accent: "#ff5aaf",
  },
  purple: {
    name: "Purple",
    screen: "#0a0012",
    text: "#bf00ff",
    dim: "#730099",
    glow: "0 0 15px rgba(191,0,255,0.2), 0 0 40px rgba(191,0,255,0.06)",
    border: "#220033",
    accent: "#cc33ff",
  },
  orange: {
    name: "Orange",
    screen: "#120800",
    text: "#ff6600",
    dim: "#993d00",
    glow: "0 0 15px rgba(255,102,0,0.2), 0 0 40px rgba(255,102,0,0.06)",
    border: "#331a00",
    accent: "#ff8533",
  },
  yellow: {
    name: "Yellow",
    screen: "#121000",
    text: "#ffee00",
    dim: "#998f00",
    glow: "0 0 15px rgba(255,238,0,0.2), 0 0 40px rgba(255,238,0,0.06)",
    border: "#332e00",
    accent: "#fff233",
  },
  white: {
    name: "White",
    screen: "#080808",
    text: "#d0d0d0",
    dim: "#707070",
    glow: "0 0 15px rgba(208,208,208,0.12), 0 0 40px rgba(208,208,208,0.04)",
    border: "#1a1a1a",
    accent: "#e0e0e0",
  },
};

export const CRT_PALETTE = ["green", "amber", "cyan", "pink", "purple", "orange", "yellow", "white"];

// Map old neon palette keys to CRT (for DB compat)
export const NEON_COLORS = CRT_COLORS;
export const NEON_PALETTE = CRT_PALETTE;
